// src/hooks/macro/useFXCommodities.ts

import { useQuery } from "@tanstack/react-query";
import { fxCommoditiesQueryOptions } from "@/services/queries/macro/fxCommoditiesQueries";
import type { FxCommodity } from "@/types/dashboards/macro";

export interface UseFXCommoditiesOptions {
  enabled?: boolean;
  refetchInterval?: number;
}

export interface UseFXCommoditiesResult {
  data: FxCommodity[] | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
  isSuccess: boolean;
  isError: boolean;
}

/**
 * React hook for fetching FX and commodities data
 * @param options - Configuration options for the data fetch
 * @returns Object containing data, loading state, error, and refetch function
 */
export const useFXCommodities = (
  options: UseFXCommoditiesOptions = {}
): UseFXCommoditiesResult => {
  const { enabled = true, refetchInterval } = options;

  const { data, isLoading, error, refetch, isSuccess, isError } = useQuery({
    ...fxCommoditiesQueryOptions(),
    enabled,
    ...(refetchInterval !== undefined && { refetchInterval }),
  });

  return {
    data: data?.data,
    isLoading,
    error: error as Error | null,
    refetch,
    isSuccess,
    isError,
  };
};

export default useFXCommodities;
